<template>
  <el-dialog
    title="企业微信客服"
    :visible="visible"
    custom-class="normal-dialog full-dialog"
    @close="visible = false"
    top="20%"
    width="420px"
  >
    <div class="custom-service">
      <p>客服时间：周一至周五10:00 - 18:00（节假日除外）</p>
      <div class="code">
        <img :src="codeImg" alt="" />
      </div>
      <a>微信扫码添加企业微信，享受1对1专属顾问</a>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      codeImg: 'https://xiaobaogong-www.oss-cn-shenzhen.aliyuncs.com/img/实证客服2.png'
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    visible: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit('update:show', val);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.custom-service {
  padding: 40px 0;
  text-align: center;
  .code {
    width: 160px;
    height: 160px;
    margin: 20px auto;
    img {
      display: block;
      width: 100%;
    }
  }
  a {
    color: #1991fb;
  }
}
</style>
